import {
  Alert,
  AlertExplanationContext,
  AlertsCommentary,
  GenerateCommentaryField,
  alertRequiresNavAttention,
  generateCommentaryPage,
  schAlertType,
} from '@aloft/toolkit-shared';

import { isAlertActiveOnRoute } from '../../hooks/validation/useAppraisifyNavigation.ts';
import { toRequiredFieldTargetCellKey } from '../../modules/alerts/requiredFieldFocus.ts';

export const SHOW_GENERATE_COMMENTARY = false;

export const shouldShowGenerateCommentary = (isAdmin: boolean) =>
  SHOW_GENERATE_COMMENTARY || isAdmin;

export const blockingCommentaryAlerts = (
  alerts: Alert[],
  field: GenerateCommentaryField,
  alertsCommentary?: AlertsCommentary,
  explanationContext?: AlertExplanationContext,
): Alert[] => {
  const page = generateCommentaryPage(field);
  const selfKey = toRequiredFieldTargetCellKey(page, field);

  return alerts.filter((alert) => {
    if (alert.severity !== 'error') return false;
    if (!alertRequiresNavAttention(alert, alertsCommentary, explanationContext)) return false;
    if (!isAlertActiveOnRoute(alert, page)) return false;
    if (
      alert.type === schAlertType.enum.incompleteRequiredFields &&
      alert.fixingInfo.targetCellKey === selfKey
    ) {
      return false;
    }
    return true;
  });
};
